import { forwardRef, type Ref, type SVGProps } from "react";

function SvgParachute(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        d="M13.7255 6.95455C15.0254 5.49091 11.3968 1.5 8.12875 1.5C4.86075 1.5 0.956284 5.4 2.25634 6.95455M13.7255 6.95455C14.459 6.12868 13.0956 5.075 12.0063 5.075C10.917 5.075 9.84416 5.84998 9.84416 6.95455M13.7255 6.95455L9.33333 12.1667M9.84416 6.95455C9.84416 5.84998 9.21808 5.075 8.12875 5.075C7.03941 5.075 6.14454 5.84998 6.14454 6.95455M9.84416 6.95455L8.33333 12.1667M6.14454 6.95455C6.14454 5.84998 5.29562 5.075 4.20629 5.075C3.11695 5.075 1.54773 6.10723 2.25634 6.95455M6.14454 6.95455L7.66667 12.1667M2.25634 6.95455L6.63333 12.1667M6.63333 12.1667H9.33333M6.63333 12.1667V14C6.63333 14.2761 6.85719 14.5 7.13333 14.5H8.83333C9.10948 14.5 9.33333 14.2761 9.33333 14V12.1667"
        stroke="currentColor"
        strokeWidth={0.8}
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgParachute);
export default ForwardRef;
